import { render, staticRenderFns } from "./selectPermission.vue?vue&type=template&id=2dc85007&"
import script from "./selectPermission.vue?vue&type=script&lang=ts&"
export * from "./selectPermission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports